export default {
  mainTitle: {
    id: 'product_page_obsolete_software_modal_main_title',
    defaultMessage: 'The “Obsolete” MacBook',
  },
  description: {
    id: 'product_page_obsolete_software_modal_description',
    defaultMessage:
      'This MacBook won’t get the newest OS update, but it’s still capable of everyday tasks at a lower price.',
  },
  descriptionLinkText: {
    id: 'product_page_obsolete_software_modal_description_link_text',
    defaultMessage: 'Learn more about “Obsolete”',
  },
  descriptionLinkUrl: {
    id: 'product_page_obsolete_software_modal_description_link_url',
    defaultMessage: '',
  },
  item1Title: {
    id: 'product_page_obsolete_software_modal_item_1_title',
    defaultMessage: 'Limited software updates ',
  },
  item1Description: {
    id: 'product_page_obsolete_software_modal_item_1_description',
    defaultMessage:
      'At this age, this MacBook can’t get the newest system, but they’ve still got plenty of good years left. Plus, ongoing security patches to keep you safe.',
  },
  item2Title: {
    id: 'product_page_obsolete_software_modal_item_2_title',
    defaultMessage: 'Battery health guaranteed',
  },
  item2Description: {
    id: 'product_page_obsolete_software_modal_item_2_description',
    defaultMessage:
      'All MacBooks on Back Market have at least 80% battery health. No matter the age.',
  },
  item3Title: {
    id: 'product_page_obsolete_software_modal_item_3_title',
    defaultMessage: 'Restored professionally',
  },
  item3Description: {
    id: 'product_page_obsolete_software_modal_item_3_description',
    defaultMessage:
      'Tested and checked by industry pros, backed by a 1-year warranty and free 30-day returns.',
  },
}
